<div class="container-fluid">
  <!--1° First Row-->
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-5 offset-md-3">
      <mat-tab-group color="warn" backgroundColor="primary">
        <mat-tab label="Login" class="text-white" *ngIf="!identity">
          <div class="card mt-2">
            <div class="card-body">
              <div class="card">
                <div class="card-header text-center">
                  <strong
                    ><h5 style="color: black; font-weight: bold">
                      {{ ilustrations[0].titulo }}
                    </h5></strong
                  >
                  <a [routerLink]="['']"
                    ><img
                      src="{{ ilustrations[0].imagen }}"
                      class="img-fluid"
                      style="max-width: 100%; height: auto"
                  /></a>
                </div>
                <div class="card-body">
                  <blockquote class="blockquote text-center">
                    <!--LOGIN-->
                    <app-login></app-login>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <!--2° Second Tab-->
        <mat-tab label="Perfil de Usuario" class="text-white" *ngIf="identity">
          <div class="row">
            <div class="col-md-12">
              <div class="card user-card">
                <div class="card-block">
                  <div class="d-flex justify-content-center h-100 text-center">
                    <div class="image_outer_container">
                      <div class="green_icon"></div>
                      <div class="image_inner_container">
                        <img src="{{ identity.picture }}" />
                      </div>
                    </div>
                  </div>
                  <h6 class="f-w-600 m-t-25 m-b-10">
                    {{ identity.name + " " + identity.family_name }}
                  </h6>
                  <p class="text-muted">{{ identity.email }}</p>
                  <hr />
                  <p class="m-t-15 text-muted">
                    Para mas información visitar
                    <a href="https://webkonce.cl" target="_blank"
                      >https://webkonce.cl</a
                    >.
                  </p>
                  <hr />
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card">
                        <img
                          src="../../assets/services/ilustrations/santiago.png"
                          width="100%"
                          height="auto"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-center user-social-link">
                    <div class="col-auto">
                      <a href="https://www.facebook.com/webkonce"
                        ><i class="fa fa-facebook text-facebook"></i
                      ></a>
                    </div>
                    <div class="col-auto">
                      <a href="https://www.instagram.com/franroav/"
                        ><i class="fa fa-instagram text-instagram"></i
                      ></a>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <a
                      [routerLink]="['logout', 1]"
                      class="btn btn-block btn-danger text-white text-center"
                      ><i class="fa fa-sign-out"></i> Salir
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <!--3° Third Tab-->
        <mat-tab label="Desarrollador" class="text-white" *ngIf="identity">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <table
                  class="table table-responsive table-sm table-striped text-center"
                  *ngIf="windowSize.x >= 960"
                >
                  <thead>
                    <tr>
                      <th>Imagen</th>
                      <th>Nombre</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <img
                          class="media-object dp img-circle"
                          src="../../assets/services/ilustrations/yo.jpg"
                          style="width: 100px; height: 100px"
                        />
                      </td>
                      <td>Francisco Javier Roa Valenzuela</td>
                      <td>
                        <tr>
                          <td>
                            <a href="mailto:franroav@webkonce.cl">
                              <i
                                class="fa fa-envelope text-center text-danger text-center"
                              ></i>
                            </a>
                          </td>
                        </tr>
                      </td>
                      <td>
                        <tr>
                          <td>
                            <a href="tel:+56932243182">
                              <i
                                class="fa fa-phone text-center text-danger ml-2 pr-1"
                              ></i>
                            </a>
                          </td>
                          <td>
                            <a
                              href="https://web.whatsapp.com/send?phone=56932243182&text=Hola, tengo una consulta"
                            >
                              <i
                                class="fa fa-whatsapp text-center text-success ml-2"
                              ></i>
                            </a>
                          </td>
                        </tr>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Profesión</th>
                      <th>Portafolio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <ul class="list-group">
                          <li
                            class="list-group-item list-group-item-light text-dark"
                          >
                            <strong>Ingeniero Civil Mecanico</strong>
                          </li>
                          <li
                            class="list-group-item list-group-item-dark text-white"
                          >
                            <strong>Desarrollador Web Fullstack</strong>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul>
                          <li>
                            <a href="https://www.concepcion.cl"
                              >https://www.concepcion.cl</a
                            >
                          </li>
                          <li>
                            <a href="https://www.proclima.cl"
                              >https://www.proclima.cl</a
                            >
                          </li>
                          <li>
                            <a href="http://friet.webkonce.cl/"
                              >http://friet.webkonce.cl/</a
                            >
                          </li>
                          <li>
                            <a href="http://clinicaroadent.cl/"
                              >http://clinicaroadent.cl/</a
                            >
                          </li>
                          <li>
                            <a href="https://www.dentobeli.cl/"
                              >https://www.dentobeli.cl/</a
                            >
                          </li>
                          <li>
                            <a href="http://cmvc.cl/">http://cmvc.cl/</a>
                          </li>
                          <li>
                            <a href="https://lalocura.cl/"
                              >https://lalocura.cl/</a
                            >
                          </li>
                          <li>
                            <a href="https://reconectaconce.webkonce.cl/"
                              >https://reconectaconce.webkonce.cl/</a
                            >
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Sitio Web</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <a href="https://webkonce.cl" target="_blank"
                          >https://webkonce.cl</a
                        >.
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  class="table table-responsive table-sm table-striped text-center"
                  *ngIf="windowSize.x < 960"
                >
                  <thead>
                    <tr>
                      <th>Imagen</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <img
                          class="media-object dp img-circle"
                          src="../../assets/services/ilustrations/yo.jpg"
                          style="width: 100px; height: 100px"
                        />
                      </td>
                      <td>
                        <ul>
                          <li>Francisco Javier Roa Valenzuela</li>
                          <li>
                            <a href="mailto:franroav@webkonce.cl">
                              <i
                                class="fa fa-envelope text-center text-danger text-center"
                              ></i>
                            </a>
                          </li>
                          <li>
                            <a href="tel:+56932243182">
                              <i
                                class="fa fa-phone text-center text-danger ml-2 pr-1"
                              ></i>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://web.whatsapp.com/send?phone=56932243182&text=Hola, tengo una consulta"
                            >
                              <i
                                class="fa fa-whatsapp text-center text-success ml-2"
                              ></i>
                            </a>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Profesión</th>
                      <th>Portafolio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <ul class="list-group">
                          <li
                            class="list-group-item list-group-item-light text-dark"
                          >
                            <strong>Ingeniero Civil Mecanico</strong>
                          </li>
                          <li
                            class="list-group-item list-group-item-dark text-white"
                          >
                            <strong>Desarrollador Web Fullstack</strong>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul>
                          <li>
                            <a href="https://www.concepcion.cl"
                              >https://www.concepcion.cl</a
                            >
                          </li>
                          <li>
                            <a href="https://www.proclima.cl"
                              >https://www.proclima.cl</a
                            >
                          </li>
                          <li>
                            <a href="http://friet.webkonce.cl/"
                              >http://friet.webkonce.cl/</a
                            >
                          </li>
                          <li>
                            <a href="http://clinicaroadent.cl/"
                              >http://clinicaroadent.cl/</a
                            >
                          </li>
                          <li>
                            <a href="https://www.dentobeli.cl/"
                              >https://www.dentobeli.cl/</a
                            >
                          </li>
                          <li>
                            <a href="http://cmvc.cl/">http://cmvc.cl/</a>
                          </li>
                          <li>
                            <a href="https://lalocura.cl/"
                              >https://lalocura.cl/</a
                            >
                          </li>
                          <li>
                            <a href="https://reconectaconce.webkonce.cl/"
                              >https://reconectaconce.webkonce.cl/</a
                            >
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Sitio Web</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <a href="https://webkonce.cl" target="_blank"
                          >https://webkonce.cl</a
                        >.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </mat-tab>
        <!--4° Fourth Tab Geolocalización -->
        <!--<mat-tab label="Mapa" class="text-white" *ngIf="identity">
                            MAP 
                  <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12 mt-1">
                      <google-map
                        width="100%"
                        height="auto"
                        [center]="position"
                        class="img-fluid"
                      >
                        <map-marker [position]="position" [label]="label">
                        </map-marker>
                      </google-map>
                    </div>
                  </div>
        </mat-tab>-->
      </mat-tab-group>
    </div>
  </div>
</div>
